import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';

/**
 * A hook that captures & communicates the current scroll position on the page
 */
export function useScrollPosition() {
  const [scrollPos, setScrollPos] = useState(0);

  const handleScroll = debounce(() => {
    const currentScrollPos = window.scrollY;
    setScrollPos(currentScrollPos);
  });

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);

  }, [scrollPos]);

  return {
    setScrollPos,
    scrollPos,
  };
}
